import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getTransmissionAnalytic } from "app/services/dashboard/transmissionAnalyticService";
import { BASE_URL } from "static/constants";

export const transmissionAnalyticApi = createApi({
  reducerPath: "transmissionAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getTransmissionAnalytic: builder.query({
      queryFn: ({ account, startDate, endDate }) => {
        return {
          data: getTransmissionAnalytic({ account, startDate, endDate }),
        };
      },
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useGetTransmissionAnalyticQuery } = transmissionAnalyticApi;
